/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/New/ReferralSource/Content/Referrals/Referral/Source/Search/SearchBar/Trigger",
  onFocus,
  onChange
  
}) {
let patientSelectSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'patient_select',
path: 'search_term',
})
let patientSelectSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'patient_select',
path: 'search_term',
})
let referralTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'referral',
path: 'template.id',
})
let constantData = 'Professional'
let aggregateData = fromAggregate.equals(referralTemplateIdValueData, constantData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 autoFocus={true}
 onFocus={onFocus}
 marginTop={0}
 type="text"
 data="patient_select.search_term"
 value={patientSelectSearchTermValueData}
 onChange={patientSelectSearchTermChangeData}
 required={true}
 placeholder={aggregateData ? "Search with professional name" : "Search with patient name"}
 data="referral.template.id"
 data="'Professional'"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 color={dtColorsBlack}
 text="Source"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}